var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHyperlink = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.25 17.915.084.086c2.756 2.756 7.237 2.764 9.995.005l5.011-5.01c2.75-2.75 2.756-7.234-.005-9.996-2.756-2.756-7.237-2.764-9.996-.005l-3.094 3.094 4.612.388.983-.982a3.537 3.537 0 0 1 4.995.005 3.54 3.54 0 0 1 .005 4.995l-5.01 5.011a3.537 3.537 0 0 1-5.08-.092z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 10.743a7.19 7.19 0 0 0-.085-.086c-2.756-2.756-7.236-2.764-9.995-.005l-5.01 5.01c-2.75 2.75-2.757 7.234.004 9.996 2.756 2.756 7.237 2.764 9.996.005l3.094-3.094-4.612-.389-.982.983a3.537 3.537 0 0 1-4.995-.005 3.54 3.54 0 0 1-.006-4.996l5.011-5.01a3.537 3.537 0 0 1 5.079.092l2.5-2.501z"
  }))));
};
export default SvgHyperlink;